/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Il nostro team Workplace Experience ora compirà la sua magia per la richiesta di un regalo. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Apprezzamenti creati',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Abbiamo inviato gli apprezzamenti, ma non abbiamo potuto inviare il regalo a causa di un errore. Invia un ticket separato a <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Impossibile inviare il regalo',
  'team-central.give-kudos.button': 'Complimentati',
  'team-central.give-kudos.close-button.label': 'Chiudi il cassetto',
  'team-central.give-kudos.confirm-close.title': 'Conferma la chiusura',
  'team-central.give-kudos.created.description.flag': 'I tuoi apprezzamenti sono stati inviati. <a>Visualizza gli apprezzamenti</a>',
  'team-central.give-kudos.created.title.flag': 'Apprezzamenti creati',
  'team-central.give-kudos.success-icon.label': 'Operazione riuscita',
  'team-central.give-kudos.unsaved.warning': 'Le modifiche apportate non saranno salvate.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Annulla',
  'team-central.give-kudos.unsaved.warning.close': 'Chiudi'
};